export function median(values: readonly number[]): number {
  const sorted = values.toSorted((a, b) => a - b);
  const middle = sorted.slice(
    Math.floor((sorted.length - 1) / 2),
    Math.floor(sorted.length / 2) + 1,
  );
  return middle.reduce((sum, score) => sum + score, 0) / middle.length;
}

export function rankOf({
  scores,
  won,
  seatIndex,
  mine,
}: {
  readonly scores: readonly number[];
  readonly won: readonly (boolean | null)[];
  readonly seatIndex: number;
  readonly mine: number;
}): number {
  if (won.every((value) => value === null)) {
    return 1 + scores.filter((score) => score > mine).length;
  }

  const mineWon = won[seatIndex] === true;
  let beatMe = 0;

  for (const [i, score] of scores.entries()) {
    if (i === seatIndex) continue;

    const otherWon = won[i] === true;

    // A declared win ranks above any score from a seat that did not win.
    if (otherWon !== mineWon ? otherWon : score > mine) beatMe++;
  }

  return 1 + beatMe;
}
